import { Modal, Spinner } from 'react-bootstrap';
import styles from './SpinnerModal.module.css';

export const SpinnerModal = (props: any) => {
  return (
    <Modal
      {...props}
      size="lg"
      centered
      keyboard={false}
      contentClassName="text-center"
      >
        <Modal.Header className={styles.spinnerModal}>
          <Modal.Title>Loading...</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please wait!</p>
          <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
          </Spinner>
        </Modal.Body>
      </Modal>
  );
}
